import { BankInstitution } from 'app/shared/models/bank-institution.model';

/**
 * Model to map bank accounts.
 */
export class BankAccount {
    accountId: number;
    accountNumber: string;
    accountName: string;
    accountHolderEntityId: number;
    bankInstitutionId: number;
    bankInstitutionName: string;
    currencyId: number;
    currencyValue: string;
    signatureRights: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/bank-account.model.ts